<!-- <div class="logo">
<a href="https://albert-ing.com/" class="simple-text">
  <div class="logo-img">
    <img src="{{squirreltext}}" />
  </div>
  Squirrel 3.0
</a>
</div> -->
<div class="sidebar-wrapper ps">
  <div class="side-nav-scroll">
  @if (isMobileMenu()) {
    <div>
      <ul class="nav navbar-nav nav-mobile-menu">
        <li class="nav-item dropdown">
          <a class="nav-link" href="javascript:void(0)" id="navbarDropdownMenuLink" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <img src="{{avatar}}" class="rounded-circle" class="avatar" alt="Avatar" loading="lazy"
              style="width:30px; height: 30px; margin: 0 6px 0 6px; border-radius:50%" />
              User Actions
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
              @for (item of items; track item) {
                <a class="dropdown-item {{item.icon}}" [routerLink]="[item.path]">
                  {{this.translate.data[item.text] | translate}}
                </a>
              }
            </div>
          </li>
        </ul>
      </div>
    }

    @if (_tenantName) {
      <ul class="nav">
        <!-- <li class="nav-item">
        <a class="select-tenant" [routerLink]="['/select-tenant']">
          <span> {{_tenantName}}</span>
        </a>
      </li> -->
      <!-- <li class="nav-item">
      <p *ngIf="defaultTenantdb && !showTenantSelect" class="select-tenant" (click)="onChangeTenant('start')">
        {{currentTenantdb ? currentTenantdb : defaultTenantdb}}
      </p>
      <mat-form-field class="select-tenant" *ngIf="defaultTenantdb && showTenantSelect">
        <mat-select placeholder="Tenants" [(ngModel)]="defaultTenantdb" libAutofocus>
          <div (blur)="onChangeTenant('cancel')" (mouseleave)="onChangeTenant('confirm',$event)">
            <mat-option *ngFor="let tenant of tenants" [value]="tenant.name">
              <span> {{tenant.displayName}}</span>
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </li> -->
    @if (projectUrl) {
      <li class="nav-item" matTooltip="{{this.translate.data['BUTTONVIEWMODEL'] | translate}}"
        #elem id="project-model" style="background-color: #def1ff;">
        <a class="nav-link side-link" (click)="createSession(squirrelSessionRequest)">
          <i class="material-icons">launch</i>
          <p>{{this.translate.data['TOVIEWMODEL'] | translate}}</p>
        </a>
      </li>
    }
    <!-- <li class="nav-item" routerLinkActive="active" *ngFor="let item of menuItems"
    [hidden]="getPermission(item.permission)">
    <a class="nav-link" [routerLink]="[item.path]">
      <i class="material-icons ">{{item.icon}}</i>
      <p>{{item.title}}</p>
    </a>
  </li> -->
  <!-- fällt evtl. weg, solange Dashboard keinen Nährwert hat -->
  <!-- <li routerLinkActive="active" *ngIf="_tenantName != _SystemManagerAbbrev" class="nav-item">
  <a class="nav-link" [routerLink]="['/', _tenantName, 'dashboard']">
    <i class="material-icons">dashboard</i>
    <p>Dashboard</p>
  </a>
</li> -->
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active" class="nav-item">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'all-projects']">
      <i class="material-icons">folder</i>
      <p>{{this.translate.data['USERPROJECTS'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active"   class="nav-item" [hidden]="!(_userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
    <!-- <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'tenant-grouproles']"> -->
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'tenant-groups']">
      <i class="material-icons">groups</i>
      <p>{{this.translate.data['TENANTGROUPROLES'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev && (_userRoles.includes('MANAGE_PROJECTS') || _userRoles.includes('CREATE_PROJECT') || _userRoles.includes('TENANTADMIN') ||  _userRoles.includes('admin'))) {
  <li routerLinkActive="active"
    class="nav-item"
    >
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-projects']">
      <i class="material-icons">folder_special</i>
      <p>{{this.translate.data['PROJECTS'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active"   class="nav-item" [hidden]="!(_userRoles.includes('TENANTADMIN') ||  _userRoles.includes('admin'))">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'project-role-templates']">
      <i class="material-icons">collections</i>
      <p>{{this.translate.data['PROJECTTEMPLATES'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active"  class="nav-item"
    [hidden]="!(_userRoles.includes('MANAGE_USERS') || _userRoles.includes('CREATE_USER') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-users']">
      <i class="material-icons">manage_accounts</i>
      <p>{{this.translate.data['USERS'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantName == 'DEMOZUGANG') {
  <li routerLinkActive="active"  class="nav-item"
    [hidden]="!(_userRoles.includes('CREATE_DEMOUSER') || _userRoles.includes('admin'))">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-demousers']">
      <i class="material-icons">groups_2</i>
      <p>{{this.translate.data['DEMOUSERS'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active"  class="nav-item"
    [hidden]="!(_userRoles.includes('CREATE_APITOKEN') || _userRoles.includes('CREATE_OWN_APITOKEN') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-apitokens']">
      <i class="material-icons">vpn_key</i>
      <p>API Token</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active"  class="nav-item"
    [hidden]="!(_userRoles.includes('MANAGE_AUDIT') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-audit']">
      <i class="material-icons">list</i>
      <p>Audit Log</p>
    </a>
  </li>
}
@if (_tenantNameCheck != _SystemManagerAbbrev) {
  <li routerLinkActive="active"  class="nav-item"
    [hidden]="!(_userRoles.includes('MANAGE_AUDIT') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-files']">
      <i class="material-icons">download</i>
      <p>Dateidownload</p>
    </a>
  </li>
}
<!-- <div class="admin-color"> -->
<!-- SM SystemManager -->
<!-- ================ -->
@if (_tenantNameCheck == _SystemManagerAbbrev) {
  <li routerLinkActive="active"  class="nav-item" [hidden]="!_userRoles.includes('admin')">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-tenants']">
      <i class="material-icons">diversity_2</i>
      <p>{{this.translate.data['TENANTS'] | translate}}</p>
    </a>
  </li>
}
<!-- <li routerLinkActive="active"   *ngIf="_tenantName == _SystemManagerAbbrev" class="nav-item" [hidden]="!dbRole">
<a class="nav-link side-link" [routerLink]="['/', _tenantName, 'manage-platform-grouproles']">
  <i class="material-icons">archive</i>
  <p>{{this.translate.data['PLATFORMGROUPROLES'] | translate}}</p>
</a>
</li> -->
@if (_tenantNameCheck == _SystemManagerAbbrev) {
  <li routerLinkActive="active"   class="nav-item" [hidden]="!_userRoles.includes('admin')">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'database-migrations']">
      <i class="material-icons">upload</i>
      <p>{{this.translate.data['DATABASEMIGRATION'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck == _SystemManagerAbbrev) {
  <li routerLinkActive="active"   class="nav-item" [hidden]="!_userRoles.includes('admin')">
    <a class="nav-link side-link" [routerLink]="['/', _tenantName, 'database-updates']">
      <i class="material-icons">update</i>
      <p>{{this.translate.data['DATABASEUPDATE'] | translate}}</p>
    </a>
  </li>
}
@if (_tenantNameCheck == _SystemManagerAbbrev) {
  <li routerLinkActive="active"   class="nav-item" class="nav-item" [hidden]="!_userRoles.includes('admin')">
    <a class="nav-link side-link" (click)="navigateToLink()" style="cursor: pointer;" >
      <!-- <mat-icon class="material-icons" style="cursor: pointer;">manage_accounts</mat-icon> -->
      <i class="material-icons">manage_accounts</i>
      Identity Admin
    </a>
  </li>
}
<!-- </div> -->
</ul>
}
  </div>
<div class="sq-footer">
  <squirrel-footer></squirrel-footer>
</div>
</div>